var _style;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_x32_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      width: 32,
      height: 32,
      opacity: 1
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#4B4B4B;}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M86.972,131.45v336.072H512V131.45H86.972z M224.108,191.528c23.356,0,42.289,18.932,42.289,42.282 c0,23.356-18.932,42.288-42.289,42.288c-23.349,0-42.282-18.932-42.282-42.288C181.826,210.46,200.759,191.528,224.108,191.528z  M130.341,412.146l62.233-94.824c3.568-5.436,9.466-8.895,15.952-9.358c6.486-0.463,12.809,2.123,17.11,7.003l37.078,42.019 l67.189-102.236c3.853-5.86,10.385-9.397,17.404-9.397c7.011-0.008,13.559,3.514,17.419,9.366l103.897,157.428H130.341z",
    style: {
      fill: "rgb(75, 75, 75)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "378.756,44.478 0,44.478 0,348.925 47.439,348.925 47.439,91.917 378.756,91.917  ",
    style: {
      fill: "rgb(75, 75, 75)"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconImg);
export default __webpack_public_path__ + "static/media/icon-img.05a4c4d75bc78f4e45e816350ffde72c.svg";
export { ForwardRef as ReactComponent };